import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = ["disabled"]

import { computed, toRef } from 'vue'
    import type { ProjectWorkspaceSwitcherViewModel } from '@Projects/Components/ProjectWorkspaceSwitcher'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectWorkspaceSwitcher',
  props: {
    viewModel: {}
  },
  emits: ["move-project"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const initialized = computed(() => vm.value.initialized)
    const workspaces = computed(() => vm.value.workspaces)

    const workspaceId = computed(() => vm.value.workspaceId)
    const projectName = computed(() => vm.value.projectName)

    const newWorkspaceId = computed<number>({
        get: () => vm.value.newWorkspaceId,
        set: val => { vm.value.newWorkspaceId = val }
    })

    // ---------------- methods ----------------

    function handleMoveProject()
    {
        if (newWorkspaceId.value !== workspaceId.value)
        {
            emit('move-project', vm.value.projectId, newWorkspaceId.value)
        }
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "modal-title" }, "Switch Workspace for Your Project", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("p", null, [
                        _cache[3] || (_cache[3] = _createTextVNode("Move your project ", -1 /* CACHED */)),
                        _createElementVNode("strong", null, "'" + _toDisplayString(projectName.value) + "'", 1 /* TEXT */),
                        _cache[4] || (_cache[4] = _createTextVNode(" to a different workspace. Select the destination workspace from the list below.", -1 /* CACHED */))
                      ]),
                      _createElementVNode("p", null, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newWorkspaceId).value = $event)),
                          class: "form-control"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspaces.value, (w) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: w.WorkspaceId
                            }, _toDisplayString(w.Name), 9 /* TEXT, PROPS */, _hoisted_8))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, newWorkspaceId.value]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: handleMoveProject,
                  disabled: newWorkspaceId.value === workspaceId.value,
                  class: "btn btn-primary"
                }, "Save", 8 /* PROPS */, _hoisted_10),
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})